/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyYen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.247 1.341 1.506 1.318-6.754 7.716V12H19v2h-6v2h6v2h-6v5h-2v-5H5v-2h6v-2H5v-2h6v-1.625L4.246 2.66l1.507-1.32L12 8.481z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyYen as CurrencyYen };
